import { Grid, getObject } from '@syncfusion/ej2-grids';
import { DetailRow as detailrow } from '@syncfusion/ej2-grids';
import { isNullOrUndefined, addClass } from '@syncfusion/ej2-base';
import { getExpandStatus, isRemoteData } from '../utils';
/**
 * TreeGrid Detail Row module
 *
 * @hidden
 */
export class DetailRow {
    constructor(parent) {
        Grid.Inject(detailrow);
        this.parent = parent;
        this.addEventListener();
    }
    /**
     * @hidden
     */
    /**
     * For internal use only - Get the module name.
     *
     * @private
     * @returns {string} Returns DetailRow module name
     */
    getModuleName() {
        return 'detailRow';
    }
    addEventListener() {
        this.parent.on('dataBoundArg', this.dataBoundArg, this);
        this.parent.on('detaildataBound', this.detaildataBound, this);
        this.parent.grid.on('detail-indentcell-info', this.setIndentVisibility, this);
        this.parent.on('childRowExpand', this.childRowExpand, this);
        this.parent.on('rowExpandCollapse', this.rowExpandCollapse, this);
        this.parent.on('actioncomplete', this.actioncomplete, this);
    }
    /**
     * @hidden
     * @returns {void}
     */
    removeEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off('dataBoundArg', this.dataBoundArg);
        this.parent.off('detaildataBound', this.detaildataBound);
        this.parent.off('childRowExpand', this.childRowExpand);
        this.parent.off('rowExpandCollapse', this.rowExpandCollapse);
        this.parent.off('actioncomplete', this.actioncomplete);
        this.parent.grid.off('detail-indentcell-info', this.setIndentVisibility);
    }
    setIndentVisibility(args) {
        const visible = 'visible';
        args[`${visible}`] = false;
    }
    dataBoundArg() {
        const detailRows = this.parent.getRows().filter((e) => {
            return !e.classList.contains('e-detailrow');
        });
        for (let i = 0; i < detailRows.length; i++) {
            const elements = detailRows[parseInt(i.toString(), 10)].getElementsByClassName('e-detailrowcollapse');
            const detailData = this.parent.grid.getRowObjectFromUID(detailRows[parseInt(i.toString(), 10)].getAttribute('data-Uid'));
            const parentItem = getObject('parentItem', this.parent.grid.getCurrentViewRecords()[parseInt(i.toString(), 10)]);
            if (isNullOrUndefined(parentItem) || !isNullOrUndefined(parentItem) &&
                getExpandStatus(this.parent, detailData.data, this.parent.grid.getCurrentViewRecords())) {
                this.parent.grid.detailRowModule.expand(elements[0]);
            }
        }
    }
    childRowExpand(args) {
        const detailRowElement = args.row.getElementsByClassName('e-detailrowcollapse');
        if (!isNullOrUndefined(detailRowElement[0])) {
            this.parent.grid.detailRowModule.expand(detailRowElement[0]);
        }
    }
    rowExpandCollapse(args) {
        if (isRemoteData(this.parent)) {
            return;
        }
        for (let i = 0; i < args.detailrows.length; i++) {
            this.parent['toggleRowVisibility'](args.detailrows[parseInt(i.toString(), 10)], args.action);
        }
    }
    detaildataBound(args) {
        const data = args.data;
        const row = args.detailElement.parentElement.previousSibling;
        const index = !isNullOrUndefined(data.parentItem) ? data.parentItem.index : data.index;
        const expandClass = 'e-gridrowindex' + index + 'level' + data.level;
        const classlist = row.querySelector('.' + expandClass).classList;
        const gridClas = [].slice.call(classlist).filter((gridclass) => (gridclass === expandClass));
        const newNo = gridClas[0].length;
        const slicedclas = gridClas.toString().slice(6, newNo);
        const detailClass = 'e-griddetail' + slicedclas;
        addClass([args.detailElement.parentElement], detailClass);
    }
    actioncomplete(args) {
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
            const colSpan = (args.row.querySelectorAll('.e-editcell')[0].getAttribute('colSpan'));
            const colum = parseInt(colSpan, 10) - 1;
            args.row.querySelectorAll('.e-editcell')[0].setAttribute('colSpan', colum.toString());
        }
        const focusElement = this.parent.grid.contentModule.getRows();
        for (let i = 0; i < focusElement.length; i++) {
            focusElement[parseInt(i.toString(), 10)].cells[0].visible = false;
        }
        const focusModule = getObject('focusModule', this.parent.grid);
        const matrix = 'refreshMatrix';
        focusModule[`${matrix}`](true)({ rows: this.parent.grid.contentModule.getRows() });
    }
    /**
     * Destroys the DetailModule.
     *
     * @function destroy
     * @returns {void}
     */
    destroy() {
        this.removeEventListener();
    }
}
